import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class AuthGuardIntranet implements CanActivate {

    constructor(private router: Router, private authService: AuthService) { }

    canActivate() {        
        if (this.authService.token && this.authService.roles.indexOf("intranet") > -1) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    }
}

@Injectable()
export class AuthGuardIntranetAdmin implements CanActivate {

    constructor(private router: Router, private authService: AuthService) { }

    canActivate() {        
        if (this.authService.token && this.authService.roles.indexOf("intranet") > -1 
            || this.authService.token && this.authService.roles.indexOf("administrador") > -1) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/intranet/services/auth-guard.intranet.ts